import { fetchUserTerms } from "@terms/store/thunks/fetchUserTerms";
import { InitiateTermsArgs, TermAppearanceType, TermAssociation } from "@terms/models";
import initiateTermsPopup from "@terms/store/thunks/initiateTermsPopup";
import { AppRoute } from "@app/models/AppRoute";
import { GetAppListener } from "@shared/models/redux";

/**
 * Each time App loads user terms, the system should show initial T&C popup.
 * There are 2 scenarios:
 * 1) App initialization
 * 2) Start/End impersonation session
 * Initial T&C should contain all SiteWide and Fund(EntitledEntity) specific terms.
 * Besides, if initial page is reporting or fund profile page - initial T&C should also contain Reporting term.
 */
export const getTermsLoadedListener: GetAppListener = (addAppListener) =>
  addAppListener({
    actionCreator: fetchUserTerms.fulfilled,
    effect: (action, { dispatch }) => {
      const termsConfig: InitiateTermsArgs = {
        type: TermAppearanceType.InitializeApplication,
        associations: {
          [TermAssociation.SiteWide]: null,
          [TermAssociation.EntitledEntity]: null,
        },
      };

      const [, fundProfilePath] = AppRoute.FundProfile.split("/");

      const shouldShowReportingTerm =
        window.location.pathname.startsWith(AppRoute.ReportingBase) ||
        window.location.pathname.startsWith(`/${fundProfilePath}`);

      if (shouldShowReportingTerm) {
        termsConfig.associations![TermAssociation.Reporting] = null;
      }

      dispatch(initiateTermsPopup(termsConfig));
    },
  });
